import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkspaceTagsService = ( createDecorator('workspaceTagsService'));
export { IWorkspaceTagsService };
